export enum AppPermissionLevels {
	AnonymousUser = 'AnonymousUser',
	AllLoggedInUser = 'AllLoggedInUser',
	NotSupported = 'NotSupportedInThatApp',
	NotLoggedInUser = 'NotLoggedInUser',
}
